export default __webpack_public_path__ + "static/media/passed.8629586d.svg";